import { useState, useEffect } from "react";
import axios from "axios";

function App() {
  const [sevkiyat, setSevkiyat] = useState(16);
  const [sonuc, setSonuc] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const toplam_koli = sevkiyat * 12;
      try {
        const res = await axios.post("/api/hesapla", {
          toplam_koli,
          aylik_sevkiyat: sevkiyat,
        });
        setSonuc(res.data);
      } catch (err) {
        console.error("Hesaplama hatası:", err);
      }
    };

    fetchData();
  }, [sevkiyat]);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold mb-4 text-center">
          Depo Maliyet Hesaplama
        </h1>
        <div className="space-y-4">
          <div>
            <label className="block mb-1 font-medium">
              Aylık sevkiyat koli adedi: {sevkiyat}
            </label>
            <input
              type="range"
              min={16}
              max={25}
              value={sevkiyat}
              onChange={(e) => setSevkiyat(Number(e.target.value))}
              className="w-full"
            />
          </div>

          {sonuc && (
            <div className="space-y-2">
              <h2 className="font-semibold">
                Toplam Maliyet: £{sonuc.toplam_maliyet}
              </h2>
              <ul className="text-sm max-h-64 overflow-auto border rounded p-2">
                {sonuc.aylik_veri.map((ay) => (
                  <li key={ay.ay}>
                    Ay {ay.ay}: {ay.kalan_koli} koli, {ay.palet} palet, £
                    {ay.maliyet}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
